export default __webpack_public_path__ + "static/media/bunzl-saude-image.aa7f63a6.png";